import { render, staticRenderFns } from "./StudioLessonsPreview.vue?vue&type=template&id=7dbc5bc0&scoped=true&"
import script from "./StudioLessonsPreview.vue?vue&type=script&lang=js&"
export * from "./StudioLessonsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc5bc0",
  null
  
)

export default component.exports